var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonIconContextual',{attrs:{"data-testid":"back-button","label":"Voltar","icon":_vm.icon},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }